import { createFileRoute } from '@tanstack/react-router'
import { AuthLayout, SignUpCard } from '@/components/auth-card'

export const Route = createFileRoute('/sign-up')({ component: () => <AuthLayout showFooter={false}><SignUpCard /></AuthLayout> })
